import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
import insertScript from '../../../assets/scripts/utilities/insert-script.js'

let instanceId = 0

class VideoEmbedComponent extends Component {
  init() {
    this.container = this.element.querySelector('.video-embed__container')
    this.hitTarget = this.element.querySelector('.video-embed__hit-target')
    this.videoId = this.element.getAttribute('data-video-id')
    this.cookieNotice = this.element.querySelector('.cookie-notice')

    if (!this.container || !this.hitTarget || !this.videoId || !this.cookieNotice) {
      return
    }

    this.cookieCategory = this.cookieNotice.getAttribute('data-category') || ''
    this.consentRun = false
    this.consentTimeout = null
    this.consentTimeoutDelay = 250

    this.iframeId = `youtube-iframe-${instanceId++}`
    this.player = null

    if (!this.cookieCategory) {
      return
    }

    window.addEventListener('cf_init', () => this.loadAfterCookieConsent())
    window.addEventListener('cf_update', () => this.loadAfterCookieConsent())
    window.addEventListener('cf_consent', () => {
      window.clearTimeout(this.consentTimeout)
      window.setTimeout(() => this.loadAfterCookieConsent(true), this.consentTimeoutDelay)
    })
  }

  loadAfterCookieConsent(force = false) {
    if (!force && this.consentRun) {
      return
    }

    const consent = window.CookieFirst?.consent || {}

    // eslint-disable-next-line no-undef
    if (environment === 'development' || consent[this.cookieCategory]) {
      this.cookieNotice.setAttribute('hidden', 'hidden')
      this.hitTarget.addEventListener('click', this.onHitTargetClick.bind(this))
      this.consentRun = true
    }
  }

  async onHitTargetClick(event) {
    event.preventDefault()

    if (this.player) {
      this.player.playVideo()
    } else if (window.YT) {
      this.insertYouTubeContainer()
    } else {
      await insertScript('youtube-api-script', '//www.youtube.com/iframe_api')
      this.onHitTargetClick(event)
    }
  }

  insertYouTubeContainer() {
    const div = document.createElement('div')

    div.id = this.iframeId
    div.className = 'video-embed__iframe'

    this.hitTarget.parentNode.replaceChild(div, this.hitTarget)
    this.hitTarget = null

    const afterLoad = () => {
      this.player = new window.YT.Player(this.iframeId, {
        host: 'https://www.youtube.com',
        width: 640,
        height: 360,
        videoId: this.videoId,
        // enablejsapi: 1, // Unfortunately we can't auto-track with GA , so no reason to enable JS API -RVP
        playerVars: {
          autoplay: 1,
          hd: 1,
          showinfo: 0,
          modestbranding: 1,
          iv_load_policy: 3,
          rel: 0,
          origin: `${window.location.protocol}//${window.location.host}`,
          disablekb: 1,
        },
        events: {
          onReady: () => {
            this.element.classList.add('video-embed--loaded')
            this.player.setPlaybackQuality('hd1080')

            if (this.element.getAttribute('data-autoplay') !== null) {
              this.player.playVideo()
            }
          },
        },
      })

      window.youtubeLoaded = true
    }

    if (!window.youtubeLoaded) {
      window.onYouTubeIframeAPIReady = afterLoad
    } else {
      afterLoad()
    }
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'video-embed', VideoEmbedComponent))
